// extracted by mini-css-extract-plugin
export var body = "_ki-0";
export var sectionHeader = "_ki-4";
export var shortcutColumns = "_ki-2";
export var shortcutList = "_ki-1";
export var shortcutSection = "_ki-3";